export default __webpack_public_path__ + "static/media/Connecticut1Closed.4ab21f49.jpg";